const initialState = {
  objects: [],
}
export default {
  namespaced: true,
  state: initialState,
  actions: {
    toast ({ commit }, obj) {
      commit('push', obj)
    },
    update ({ commit }, objs) {
      commit('update', objs)
    },
  },
  mutations: {
    push (state, obj) {
      state.objects.push(obj)
    },
    update (state, objs) {
      state.objects = objs
    },
  },
  getters: {},
}
